<template>
	<div class="page">
		<!-- your page -->
		<div class="swiper">
			<div class="leftNav">
				<div class="navItem" v-for="(item,index) in navItem" :data-id="item.id" :key="index" >
					<div class="navMain"  :data-id="item.id" @mousemove="showSecond($event)" @mouseleave="hideSecond($event)">
						<div class="ItemIcon" :data-id="item.id">
							<img :src="item.icon" alt="" :data-id="item.id">
						</div>
						<div class="ItemWord" :data-id="item.id" @click="goFirstCat">
							{{item.name}}
						</div>
					</div>
					<div class="second" v-show="item.show" @mousemove="showSecond($event)" @mouseleave="hideSecond($event)" :data-id="item.id">
						<div class="secondLine" :data-id="item.id" v-for="(tab,tabIndex) in item['tab']" :key="tabIndex" :data-tid="tab.id" :data-pid="tab.pid">
							<div class="secondLineTitle" :data-id="item.id">
								{{tab.name}}
							</div>
							<div class="secondLineBox" :data-id="item.id">
								<div class="secondLineArea" :data-id="item.id">
									<div class="secondUnit" v-for="(unit,unitIndex) in tab['unit']" :key="unitIndex" :data-uid="unit.id" :data-pid="unit.pid" :data-id="item.id" @click="getCatId">
										{{unit.name}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="middle">
				<div class="smallBox">
					<div class="top">
						<div class="swiper-container">
							<el-carousel trigger="click" height="390px">
								<el-carousel-item v-for="(item,index) in swiper" :key="index">
									<a :href="item.url"><img :src="item.img" alt=""></a>
								</el-carousel-item>
							</el-carousel>
						</div>
					</div>
					<div class="bottom">
						<div class="news">
							<div class="newsIcon">
								<img src="../assets/index/news.png" alt="">
							</div>
							<div class="newsBox">
								<el-carousel height="90px" direction="vertical" :autoplay="true" :interval="2500">
									<el-carousel-item v-for="(item,index) in news" :key="index">
										<div class="newsItem" :data-id="item.id">
											<div class="newsTitle"><div class="titleBox">{{item.title}}</div><div class="newsMore" @click="goMore" :data-id="item.id">查看更多></div></div>
											<div class="newsMsg">{{item.content}}</div>
										</div>
									</el-carousel-item>
								</el-carousel>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="rightBox">
					<div class="hello" v-show="!loginStatus">
						<!-- Hi,{{userinfo.nickname}},<br> -->
						欢迎来到{{shop_name}}
					</div>
					<div class="hello" v-show="loginStatus">
						Hi,{{time}}好,<br>
						欢迎来到{{shop_name}}
					</div>
					<div class="button">
						<!-- <div class="inLog" v-show="!loginStatus">
							<button @click="goPerson">用户中心</button>
						</div>
						<div class="outLog" v-show="loginStatus">
							<button>用户登录</button>
						</div> -->
					</div>
					<div class="rightBottom">
						<div class="line" v-for="item in guard">
							<div class="lineIcon">
								<img :src="item.icon" alt="">
							</div>
							<div class="lineTitle">
								{{item.title}}
							</div>
							<div class="lineInfo">
								{{item.info}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	import $ from 'jquery'
	export default {
		name: 'swiper',
		data(){
			return {
				loginStatus:false,
				userinfo:{},
				navItem:[],
				secondShow:false,
				time:"",
				news:[],
				guard:[
					{icon:require("../assets/index/swiper1.png"),title:"正品保障",info:"资质严选 品质经审核"},
					{icon:require("../assets/index/swiper2.png"),title:"价格优惠",info:"符合优惠率"},
					{icon:require("../assets/index/swiper3.png"),title:"双向信用",info:"如实评价 信用共建"},
					{icon:require("../assets/index/swiper4.png"),title:"售后无忧",info:"交易保障 纠纷仲裁"}
				],
				swiper:[],
				shop_name:""
			}
		},
		methods:{
			fetchCopyRight(){
				var data = {
					method:"config.config"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.shop_name = res.data.shop_name
					}else{
						that.globalTest('config.config','error',res.msg,res.data)
					}
				})
			},
			getCatId(e){
				var id = e.target.dataset.uid
				this.$router.push({path:'/type',query:{'catid':id,type:'catid'}})
			},
			goFirstCat(e){
				var id = e.target.dataset.id
				this.$router.push({path:"/type",query:{"catid":id,"type":"catid"}})
			},
			fetchNotice(){
				var data = {
					method:"notice.noticeList"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.news = res.data
					}else{

					}
				})
			},
			showSecond(e){
				e.stopPropagation()
				var id = e.target.dataset.id
				var navItem = this.navItem
				for (var i = 0; i < navItem.length; i++) {
					var nid = navItem[i].id
					navItem[i].show = false
					if(id==nid){
						navItem[i].show = true
					}
				}
				this.navItem = navItem
			},
			hideSecond(e){
				e.stopPropagation()
				var navItem = this.navItem
				for (var i = 0; i < navItem.length; i++) {
					navItem[i].show = false
				}
				this.navItem = navItem
			},
			getSwiper(){
				var data = {
					code: "tpl1_slider",
					method: "advert.getAdvertList"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						var list = res.data.list
						for (var i = 0; i < list.length; i++) {
							var item = list[i]
							var obj = {
								id:item.id,
								img:item.img,
								name:item.name,
								type:item.type,
								val:item.val,
								url:item.url
							}
							that.swiper.push(obj)
						}
					}else{
						that.globalTest('advert.getAdvertList','error',res.msg,res.data)
					}
				})
			},
			getAllCat(){
				var data = {
					"method":"categories.getallcat"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						var reList = res.data
						var navItem = that.navItem
						for (var i = 0; i < reList.length; i++) {
							var item = reList[i]
							var child = item.child
							var tabList = new Array()
							for (let k in child) {
								var cItem = child[k]
								var san = cItem.san
								var unitList = new Array()
								for (let j in san) {
									var sItem = san[j]
									var unit = {
										"name":sItem.name,
										"pid":sItem.parent_id,
										"icon":sItem.image_url,
										"id":sItem.id
									}
									unitList.push(unit)
								}
								var tab = {
									"name":cItem.name,
									"pid":cItem.parent_id,
									"icon":cItem.image_url,
									"id":cItem.id,
									"unit":unitList
								}
								tabList.push(tab)
							}
							var obj = {
								"id":item.id,
								"icon":item.image_url,
								"name":item.name,
								"tab":tabList,
								"show":false
							}
							navItem.push(obj)
						}
						that.navItem = navItem
					}else{
						that.globalTest('user.info','error',res.msg,res.data)
					}
				})
			},
			getTime(){
				var date = new Date()
				var time = date.getHours()
				if(time>=6&&time<8){
					this.time="早上"
				}else if(time>=8&&time<11){
					this.time="上午"
				}else if(time>=11&&time<13){
					this.time="中午"
				}else if(time>=13&&time<17){
					this.time="下午"
				}else if(time>=17&&time<22){
					this.time="晚上"
				}else if(time>=22&&time<24){
					this.time="深夜"
				}else if(time>=0&&time<6){
					this.time="凌晨"
				}
			},
			getInfo(){
				//获取用户信息
				var that = this
				this.getUserInfo(function(res){
					that.userinfo = res
				})
			},
			goMore(e){
				var id = e.target.dataset.id
				this.$router.push({path:'/article',query:{aid:id,type:"notice"}})
			},
			goPerson(){
				this.$router.push({path:"/person",query:{mid:0}})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.token = localStorage.getItem('token')
			if(this.token!=null){
				this.logStatus = false
				this.getInfo()
			}
			this.getTime()
			this.getAllCat()
			this.getSwiper()
			this.fetchNotice()
			this.fetchCopyRight()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.swiper{
		width: 100%;
		height: 490px;
	}
	.leftNav{
		width: 200px;
		height: 100%;
		float: left;
		box-shadow: 3px 3px 3px #E3E3E3;
		position: relative;
	}
	.navItem{
		width: 100%;
		height: 35px;
		line-height: 35px;
		cursor: pointer;
	}
	.navMain{
		width: 100%;
		height: 100%;
		padding: 0px 20px;
		box-sizing: border-box;
		overflow: hidden;
	}
	.navMain .ItemWord{
		font-size: 14px;
		color: #666666;
	}
	.second{
		width: 800px;
		height: 490px;
		border: 2px solid #036DEE;
		position: absolute;
		left: 200px;
		top: 0px;
		z-index: 99;
		background: #FFFFFF;
		box-sizing: border-box;
	}
	.secondLine{
		width: 100%;
		min-height: 26px;
		position: relative;
		padding-top: 5px;
		box-sizing: border-box;
	}
	.secondLineTitle{
		width: 150px;
		height: 26px;
		position: absolute;
		left: 0px;
		top: 5px;
		padding-left: 10px;
		box-sizing: border-box;
		color: #1b365b;
		overflow: hidden;
		font-size: 14px;
		font-weight: bold;
		line-height: 26px;
	}
	.secondLine:hover .secondLineTitle{
		color: #036DEE;
	}
	.secondLineBox{
		width: 100%;
		padding-left: 150px;
		box-sizing: border-box;
	}
	.secondLineBox .secondLineArea{
		width: 100%;
		border-bottom: 1px solid #E3E3E3;
		padding-bottom: 5px;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;
	}
	.secondUnit{
		height: 26px;
		line-height: 26px;
		margin-left: 10px;
	}
	.secondUnit:hover{
		background: #F0F0F0;
		color: #036DEE;
	}
	.navItem:hover{
		background: #F0F0F0;
		color: #036DEE;
	}
	.navItem .ItemIcon{
		width: 15px;
		height: 15px;
		float: left;
		margin-top: 10px;
		margin-right: 20px;
	}
	.navItem .ItemIcon img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.middle{
		width: 750px;
		height: 100%;
		float: left;
	}
	.smallBox{
		width: 710px;
		height: 480px;
		margin: 10px auto;
		box-shadow: 3px 3px 3px #E3E3E3;
	}
	.top{
		width: 100%;
		height: 390px;
	}
	.top .swiper-container{
		width: 100%;
		height: 100%;
	}
	.top .swiper-container a img{
		width: 100%;
		height: 100%;
	}
	.bottom{
		width: 100%;
		height: 90px;
		box-shadow: -3px -3px 3px #E3E3E3;
	}
	.bottom .news{
		width: 100%;
		height: 100%;
    background: #FFFFFF;
	}
	.newsIcon{
		width: 200px;
		height: 100%;
		float: left;
	}
	.newsIcon img{
		width: 100%;
		height: 100%;
		float: left;
	}
	.newsBox{
		width: 500px;
		height: 100%;
		float: left;
		overflow: hidden;
	}
	.newsItem{
		width: 100%;
		height: 100%;
	}
	.newsTitle{
		width: 100%;
		height: 40px;
		line-height: 40px;
	}
	.newsTitle .titleBox{
		width: 430px;
		height: 100%;
		float: left;
		font-size: 14px;
	}
	.newsTitle .newsMore{
		width: 70px;
		height: 100%;
		float: right;
		font-size: 12px;
		color: #838383;
		text-align: right;
		padding-right: 10px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.newsTitle:hover{
		color: #036DEE;
	}
	.newsMore:hover{
		color: #036DEE;
	}
	.newsMsg{
		font-size: 13px;
		line-height: 22px;
		color: #838383;
	}
	.right{
		width: 250px;
		height: 100%;
		float: left;
	}
	.rightBox{
		width: 100%;
		height: 480px;
		margin-top: 10px;
		border: 1px solid #E3E3E3;
		box-shadow: 3px 3px 3px #E3E3E3;
		box-sizing: border-box;
	}
	.rightBox .hello{
		width: 100%;
		height: 75px;
		text-align: center;
		padding-top: 25px;
		box-sizing: border-box;
		line-height: 25px;
	}
	.button{
		width: 100%;
		height: 85px;
	}
	.inLog,.outLog{
		width: 100%;
		height: 100%;
	}
	.button button{
		width: 80%;
		height: 35px;
		display: block;
		margin: 0 auto;
		margin-top: 15px;
		border: none;
		cursor: pointer;
	}
	.button button:nth-child(1){
		background: -webkit-linear-gradient(left, #56a2ff , #036dee); /* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(right, #56a2ff, #036dee); /* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(right, #56a2ff, #036dee); /* Firefox 3.6 - 15 */
		background: linear-gradient(to right, #56a2ff , #036dee); /* 标准的语法 */
		color: #FFFFFF;
		border: 1px solid #036DEE;
	}
	.button button:nth-child(1):hover{
		background: none;
		border: 1px solid #036DEE;
		color: #036DEE;
	}
	.button button:nth-child(2){
		border: 1px solid #036DEE;
		color: #036DEE;
		background: none;
		box-sizing: border-box;
	}
	.button button:nth-child(2):hover{
		background: -webkit-linear-gradient(left, #56a2ff , #036dee); /* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(right, #56a2ff, #036dee); /* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(right, #56a2ff, #036dee); /* Firefox 3.6 - 15 */
		background: linear-gradient(to right, #56a2ff , #036dee); /* 标准的语法 */
		color: #FFFFFF;
	}
	.rightBottom{
		width:90%;
		height: 305px;
		margin: 0 auto;
	}
	.rightBottom .line{
		width: 100%;
		height: 75px;
		position: relative;
	}
	.rightBottom .line .lineIcon{
		width: 50px;
		height: 100%;
		float: left;
		font-size: 12px;
	}
	.rightBottom .line .lineIcon img{
		width: 26px;
		height: 26px;
		display: block;
		margin: 10px auto;
	}
	.rightBottom .line .lineTitle{
		font-size: 14px;
		width: 138px;
		float: left;
		height: 30px;
		line-height: 40px;
	}
	.rightBottom .line .lineInfo{
		font-size: 12px;
		width: 138px;
		float: left;
		height: 40px;
		line-height: 40px;
		color: #838383;
	}
</style>
